import axios from 'axios'
import { axiosInstance } from '@/lib/axios'
import { CompanyRoleInput, CompanyRoles } from './types'

export class CompanyRoleError extends Error {
  code: string

  constructor(code: string, message?: string) {
    super(message || code)
    this.code = code
    this.name = 'CompanyRoleError'
  }
}

const base = (companyId: string) => `/config-api/company/${companyId}/roles`

// Serwer zwraca błędy walidacji jako 4xx z { code, message }.
async function call<T>(request: () => Promise<{ data: T }>): Promise<T> {
  try {
    const { data } = await request()
    return data
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const body = error.response?.data as { code?: string; Code?: string; message?: string; Message?: string } | undefined
      const code = body?.code || body?.Code || (error.response?.status === 403 ? 'NOT_AUTHORIZED' : 'UNKNOWN_ERROR')
      throw new CompanyRoleError(code, body?.message || body?.Message)
    }
    throw error
  }
}

export const getCompanyRoles = (companyId: string) =>
  call(() => axiosInstance.get<CompanyRoles>(base(companyId)))

export const createCompanyRole = (companyId: string, role: CompanyRoleInput) =>
  call(() => axiosInstance.post(base(companyId), role))

export const editCompanyRole = (companyId: string, roleId: number, role: CompanyRoleInput) =>
  call(() => axiosInstance.post(`${base(companyId)}/${roleId}`, role))

export const removeCompanyRole = (companyId: string, roleId: number) =>
  call(() => axiosInstance.delete(`${base(companyId)}/${roleId}`))
